var m = require('mithril');
var prop = require('mithril/stream');
var Model = require('../../libs/Model');
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');
var alerts = require('../../layout/components/alerts');
var base = require('../../../../../models/rest/restResource');
var helpers = require('./formHelpers');

var restResource = Object.assign(Object.create(base), Model);

restResource.fields = Object.assign({}, base.fields, {
  pointConfigs: {
    default: '',
    hidden: true
  }
});
restResource.extrawidth = true;

var initForm = restResource.initForm;

var POLL_METHODS = [
  { name: 'GET', value: 'get' },
  { name: 'HEAD', value: 'head' }
];

var WRITE_METHODS = [
  { name: 'GET', value: 'get' },
  { name: 'POST', value: 'post' },
  { name: 'PUT', value: 'put' },
  { name: 'PATCH', value: 'patch' },
  { name: 'DELETE', value: 'delete' },
  { name: 'HEAD', value: 'head' },
  { name: 'OPTIONS', value: 'options' }
];

var BODY_TYPES = [
  { name: 'JSON', value: 'json' },
  { name: 'Form', value: 'form' },
  { name: 'Raw text', value: 'raw' },
  { name: 'None', value: 'none' }
];

var RESPONSE_FORMATS = [
  { name: 'Host default', value: '' },
  { name: 'JSON', value: 'json' },
  { name: 'XML', value: 'xml' },
  { name: 'HTML', value: 'html' },
  { name: 'Text', value: 'text' },
  { name: 'Auto', value: 'auto' }
];

function responseFormatValue() {
  if (restResource.form.responseFormat()) return restResource.form.responseFormat();
  if (Number(restResource.form.html())) return 'html';
  if (Number(restResource.form.xml())) return 'xml';
  return '';
}

function setResponseFormat(value) {
  restResource.form.responseFormat(value);
  restResource.form.html(value === 'html' ? 1 : 0);
  restResource.form.xml(value === 'xml' ? 1 : 0);
}

function writeModeValue() {
  var mode = restResource.form.writeMode();
  if (!mode || mode === 'legacy') return 'default';
  return mode;
}

function writeBodyTypeValue() {
  return restResource.form.writeBodyType() || 'json';
}

function hasRequestDetails() {
  return Boolean(
    restResource.form.queryParams() ||
    restResource.form.requestHeaders() ||
    restResource.form.bodyType() ||
    restResource.form.postBody() ||
    restResource.form.timeout()
  );
}

function hasResponseDetails() {
  return Boolean(
    restResource.form.responseFormat() ||
    Number(restResource.form.html()) ||
    Number(restResource.form.xml()) ||
    restResource.form.allowNon2xx() ||
    restResource.form.arrayKey() ||
    restResource.form.statusIndex() ||
    restResource.form.statusNormalValue()
  );
}

function hasWriteDetails() {
  var mode = restResource.form.writeMode();
  return Boolean(
    (mode && mode !== 'default' && mode !== 'legacy') ||
    restResource.form.writeMethod() ||
    restResource.form.writePath() ||
    restResource.form.writeBodyType() ||
    restResource.form.writeBody() ||
    restResource.form.writeHeaders() ||
    (restResource.form.writeValueKey() && restResource.form.writeValueKey() !== 'value')
  );
}

function resetResponseTest() {
  restResource.responseTest = {
    loading: prop(false),
    error: prop(''),
    result: prop(null),
    selectedPath: prop(''),
    expanded: { '$': true }
  };
}

function errorMessage(error) {
  if (typeof error === 'string') return error;
  if (error && typeof error.error === 'string') return error.error;
  if (error && typeof error.message === 'string') return error.message;
  return 'Request test failed';
}

function isBlank(value) {
  return value === null || typeof value === 'undefined' || value === '';
}

function readGeneratedPointConfigs() {
  var raw = restResource.form.pointConfigs && restResource.form.pointConfigs();
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  try {
    var parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    return [];
  }
}

function writeGeneratedPointConfigs(configs) {
  restResource.form.pointConfigs(JSON.stringify(configs || []));
}

function pathKey(segment) {
  return segment.type === 'index' ? '[' + segment.value + ']' : String(segment.value);
}

function quoteJsonPathKey(key) {
  return '[' + JSON.stringify(String(key)) + ']';
}

function jsonPathFor(segments) {
  return segments.reduce(function (path, segment) {
    if (segment.type === 'index') return path + '[' + segment.value + ']';
    if (/^[A-Za-z_$][A-Za-z0-9_$]*$/.test(segment.value)) return path + '.' + segment.value;
    return path + quoteJsonPathKey(segment.value);
  }, '$');
}

function getValueType(value) {
  if (value === null) return 'null';
  if (Array.isArray(value)) return 'array';
  return typeof value;
}

function isExpandable(value) {
  return value && typeof value === 'object';
}

function isSelectable(value) {
  return value === null || typeof value !== 'object';
}

function previewValue(value) {
  var type = getValueType(value);
  var preview;
  if (type === 'array') return 'Array(' + value.length + ')';
  if (type === 'object') return 'Object(' + Object.keys(value).length + ')';
  if (type === 'string') preview = JSON.stringify(value);
  else preview = String(value);
  return preview.length > 80 ? preview.slice(0, 77) + '...' : preview;
}

function inferPointName(segments, fallback) {
  var segment;
  for (var index = segments.length - 1; index >= 0; index--) {
    if (segments[index].type === 'property') {
      segment = String(segments[index].value);
      break;
    }
  }
  if (!segment && segments.length) segment = pathKey(segments[segments.length - 1]);
  segment = segment || fallback || 'Point';
  return String(segment)
    .replace(/[_-]+/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/^./, function (letter) { return letter.toUpperCase(); });
}

function inferUnit(value) {
  if (typeof value === 'boolean') return 'bool';
  if (typeof value === 'string') return 'str';
  return 'int';
}

function getValueAtSegments(root, segments) {
  return segments.reduce(function (value, segment) {
    if (value === null || typeof value === 'undefined') return undefined;
    return value[segment.value];
  }, root);
}

function lastIndexSegmentPosition(segments) {
  for (var index = segments.length - 1; index >= 0; index--) {
    if (segments[index].type === 'index') return index;
  }
  return -1;
}

function displayNameValue(value) {
  if (value === null || typeof value === 'undefined') return '';
  return String(value).trim();
}

function inferArrayPointName(item, relativeSegments, position) {
  var propertyName = inferPointName(relativeSegments, restResource.form.name());
  var itemName = '';

  if (item && typeof item === 'object' && !Array.isArray(item)) {
    itemName = displayNameValue(item.name || item.label || item.title || item.id || item.key);
  }

  if (itemName && itemName.toLowerCase() !== propertyName.toLowerCase()) {
    return itemName + ' ' + propertyName;
  }
  if (itemName) return itemName;
  return propertyName + ' ' + (position + 1);
}

function arraySelectionForIndex(root, segments, indexPosition) {
  var prefixSegments;
  var relativeSegments;
  var arrayValue;
  var configs;

  if (indexPosition < 0 || indexPosition === segments.length - 1) return null;

  prefixSegments = segments.slice(0, indexPosition);
  relativeSegments = segments.slice(indexPosition + 1);
  if (!relativeSegments.length) return null;

  arrayValue = getValueAtSegments(root, prefixSegments);
  if (!Array.isArray(arrayValue)) return null;

  configs = arrayValue.reduce(function (memo, item, position) {
    var value = getValueAtSegments(item, relativeSegments);
    var itemSegments;
    if (!isSelectable(value)) return memo;
    itemSegments = prefixSegments.concat({ type: 'index', value: position }).concat(relativeSegments);
    memo.push({
      name: inferArrayPointName(item, relativeSegments, position),
      jsonPath: jsonPathFor(itemSegments),
      index: 0,
      unit: inferUnit(value)
    });
    return memo;
  }, []);

  if (configs.length < 2) return null;

  return {
    arrayPath: jsonPathFor(prefixSegments),
    count: configs.length,
    propertyName: inferPointName(relativeSegments, restResource.form.name()),
    configs: configs
  };
}

function arraySelectionFor(root, segments) {
  var indexPosition = lastIndexSegmentPosition(segments);
  var selection;

  while (indexPosition >= 0) {
    selection = arraySelectionForIndex(root, segments, indexPosition);
    if (selection) return selection;
    indexPosition = lastIndexSegmentPosition(segments.slice(0, indexPosition));
  }

  return null;
}

function selectedResponseFormat() {
  var result = restResource.responseTest && restResource.responseTest.result
    ? restResource.responseTest.result()
    : null;
  return result && result.responseFormat === 'xml' ? 'xml' : 'json';
}

function pointIdentity(point) {
  if (!point) return null;
  if (!isBlank(point.jsonPath)) return 'jsonPath:' + point.jsonPath;
  if (!isBlank(point.querySelector)) {
    return [
      'querySelector:' + point.querySelector,
      'regex:' + (isBlank(point.regex) ? '' : point.regex),
      'index:' + (isBlank(point.index) ? '' : point.index)
    ].join('|');
  }
  if (!isBlank(point.regex)) return 'regex:' + point.regex + '|index:' + (isBlank(point.index) ? '' : point.index);
  if (!isBlank(point.name)) return 'name:' + point.name;
  return null;
}

function existingPointIdentityMap() {
  var map = {};
  ((restResource.record && restResource.record.children) || []).forEach(function (child) {
    var identity;
    if (!child || child.deleted === true || child['@class'] !== 'Point') return;
    identity = pointIdentity(child);
    if (identity) map[identity] = true;
  });
  return map;
}

function existingPointForConfig(config) {
  var identity = pointIdentity(config);
  return Boolean(identity && existingPointIdentityMap()[identity]);
}

function generatedPointForConfig(config) {
  var identity = pointIdentity(config);
  return Boolean(identity && readGeneratedPointConfigs().some(function (generatedConfig) {
    return pointIdentity(generatedConfig) === identity;
  }));
}

function missingPointConfigs(configs) {
  return (configs || []).filter(function (config) {
    return !existingPointForConfig(config);
  });
}

function addGeneratedPoints(newConfigs, selectedPath) {
  var configs = readGeneratedPointConfigs();
  var configsToAdd = missingPointConfigs(newConfigs);

  configsToAdd.forEach(function (config) {
    var existingIndex = configs.findIndex(function (existingConfig) {
      return pointIdentity(existingConfig) === pointIdentity(config);
    });
    if (existingIndex > -1) configs[existingIndex] = Object.assign({}, configs[existingIndex], config);
    else configs.push(config);
  });

  writeGeneratedPointConfigs(configs);
  restResource.responseTest.selectedPath(selectedPath || (newConfigs[0] && newConfigs[0].jsonPath) || '');
  setResponseFormat(selectedResponseFormat());
}

function addGeneratedPoint(jsonPath, value, segments) {
  addGeneratedPoints([{
    name: inferPointName(segments, restResource.form.name()),
    jsonPath: jsonPath,
    index: 0,
    unit: inferUnit(value)
  }], jsonPath);
}

function removeGeneratedPoint(index) {
  var configs = readGeneratedPointConfigs();
  configs.splice(index, 1);
  writeGeneratedPointConfigs(configs);
}

function updateGeneratedPoint(index, key, value) {
  var configs = readGeneratedPointConfigs();
  configs[index] = Object.assign({}, configs[index]);
  configs[index][key] = value;
  writeGeneratedPointConfigs(configs);
}

function buildTestRequestPayload() {
  return {
    resourceRid: restResource.record && restResource.record['@rid']
  };
}

function testRequest() {
  restResource.responseTest.loading(true);
  restResource.responseTest.error('');
  return loaders.requestWithLoader({
    loader: 'background',
    url: '/api/v1/restresource/test-request',
    method: 'POST',
    body: buildTestRequestPayload()
  })
  .then(function (result) {
    restResource.responseTest.result(result);
    restResource.responseTest.expanded = { '$': true };
    restResource.responseTest.loading(false);
    m.redraw();
  })
  .catch(function (error) {
    restResource.responseTest.error(errorMessage(error));
    restResource.responseTest.loading(false);
    m.redraw();
  });
}

function toggleJsonNode(jsonPath) {
  restResource.responseTest.expanded[jsonPath] = !restResource.responseTest.expanded[jsonPath];
}

function jsonNode(value, segments, label, root) {
  var jsonPath = jsonPathFor(segments);
  var expandable = isExpandable(value);
  var expanded = Boolean(restResource.responseTest.expanded[jsonPath]);
  var childKeys = expandable ? Object.keys(value) : [];
  var pointConfig = isSelectable(value) ? {
    name: inferPointName(segments, restResource.form.name()),
    jsonPath: jsonPath,
    index: 0,
    unit: inferUnit(value)
  } : null;
  var existing = pointConfig ? existingPointForConfig(pointConfig) : false;
  var generated = pointConfig ? generatedPointForConfig(pointConfig) : false;
  var selected = restResource.responseTest.selectedPath() === jsonPath || existing || generated;
  var arraySelection = isSelectable(value) ? arraySelectionFor(root, segments) : null;
  var missingArrayConfigs = arraySelection ? missingPointConfigs(arraySelection.configs) : [];
  var existingArrayCount = arraySelection ? arraySelection.configs.length - missingArrayConfigs.length : 0;
  var arrayButtonText = arraySelection
    ? existingArrayCount === arraySelection.count
      ? 'All ' + arraySelection.count + ' added'
      : existingArrayCount > 0
        ? 'Add ' + missingArrayConfigs.length + ' of ' + arraySelection.count
        : 'All ' + arraySelection.count
    : '';

  return m('div', { key: jsonPath }, [
    m('div.flex.items-start.mv1', [
      expandable ? m('button.bn.bg-transparent.near-white.pointer.ph1', {
        type: 'button',
        onclick: function () { toggleJsonNode(jsonPath); }
      }, m('i.ion-ios-arrow-' + (expanded ? 'down' : 'right'))) : m('span.dib', { style: { width: '1.5rem' } }),
      isSelectable(value) ? m('div.flex.items-start.w-100', [
        m('button.tl.bn.pointer.pa1.flex-auto', {
          type: 'button',
          class: 'near-white',
          style: {
            wordBreak: 'break-word',
            backgroundColor: existing ? '#284d36' : selected ? '#1f4358' : 'transparent'
          },
          'data-json-path': jsonPath,
          'data-existing-json-path': existing ? jsonPath : null,
          'data-generated-json-path': generated ? jsonPath : null,
          onclick: function () {
            if (existing) {
              restResource.responseTest.selectedPath(jsonPath);
              return;
            }
            addGeneratedPoint(jsonPath, value, segments);
          }
        }, [
          m('span.fw6.mr2', label),
          m('code.moon-gray.mr2', jsonPath),
          m('span.light-silver', previewValue(value)),
          existing ? m('span.ml2.f6.pa1.br1.bg-dark-green.white', 'Added') : generated ? m('span.ml2.f6.pa1.br1.bg-blue.white', 'Selected') : null
        ]),
        arraySelection ? m('button.ba.bw1.ph2.pv1.tc.v-btm.bg-black.near-white.b--mid-gray.ml2.nowrap', {
          type: 'button',
          disabled: missingArrayConfigs.length === 0,
          style: {
            cursor: missingArrayConfigs.length === 0 ? 'not-allowed' : 'pointer',
            opacity: missingArrayConfigs.length === 0 ? 0.55 : 1
          },
          title: missingArrayConfigs.length
            ? 'Add ' + missingArrayConfigs.length + ' ' + arraySelection.propertyName + ' points from ' + arraySelection.arrayPath
            : 'All ' + arraySelection.propertyName + ' points from ' + arraySelection.arrayPath + ' are already added',
          'data-array-json-path': jsonPath,
          'data-array-existing-count': existingArrayCount,
          onclick: function () { addGeneratedPoints(arraySelection.configs, jsonPath); }
        }, arrayButtonText) : null
      ]) : m('button.tl.bn.bg-transparent.near-white.pointer.pa1.w-100', {
        type: 'button',
        style: { wordBreak: 'break-word' },
        onclick: function () { toggleJsonNode(jsonPath); }
      }, [
        m('span.fw6.mr2', label),
        m('code.moon-gray.mr2', jsonPath),
        m('span.light-silver', previewValue(value))
      ])
    ]),
    expandable && expanded ? m('div.ml3.pl2.bl.b--mid-gray', childKeys.map(function (key) {
      var childSegments = segments.concat({
        type: Array.isArray(value) ? 'index' : 'property',
        value: Array.isArray(value) ? Number(key) : key
      });
      return jsonNode(value[key], childSegments, Array.isArray(value) ? '[' + key + ']' : key, root);
    })) : null
  ]);
}

function generatedPointsView() {
  var configs = readGeneratedPointConfigs();

  return helpers.section('Points to Create', [
    !configs.length ? m('p.moon-gray.mb3', 'Select response values to create points under this Rest Resource.') : null,
    configs.length ? m('table.w-100.f5.mb3.rest-generated-points-table', [
      m('thead', [
        m('tr', [
          m('th.tl.pr2', 'Name'),
          m('th.tl.pr2', 'JSONPath'),
          m('th.tl.pr2', 'Index'),
          m('th.tl.pr2', 'Unit'),
          m('th.tl', '')
        ])
      ]),
      m('tbody', configs.map(function (config, index) {
        return m('tr', { key: config.jsonPath || index }, [
          m('td.pr2.v-top', m('input.form-control', {
            type: 'text',
            value: config.name || '',
            oninput: function (ev) { updateGeneratedPoint(index, 'name', ev.target.value); }
          })),
          m('td.pr2.v-top', m('input.form-control', {
            type: 'text',
            value: config.jsonPath || '',
            oninput: function (ev) { updateGeneratedPoint(index, 'jsonPath', ev.target.value); }
          })),
          m('td.pr2.v-top', m('input.form-control', {
            type: 'text',
            value: config.index,
            oninput: function (ev) { updateGeneratedPoint(index, 'index', ev.target.value); }
          })),
          m('td.pr2.v-top', m('input.form-control', {
            type: 'text',
            value: config.unit || '',
            oninput: function (ev) { updateGeneratedPoint(index, 'unit', ev.target.value); }
          })),
          m('td.v-top', m('button.bn.bg-transparent.red.pointer.f3', {
            type: 'button',
            title: 'Remove',
            onclick: function () { removeGeneratedPoint(index); }
          }, m('i.ion-ios-close')))
        ]);
      }))
    ]) : null
  ]);
}

function responseBodyView(result) {
  var body = result && result.body;
  if (body && typeof body === 'object') {
    return m('div', [
      m('div.ba.b--mid-gray.pa2.mb3.overflow-auto', { style: { maxHeight: '26rem' } }, [
        jsonNode(body, [], 'response', body)
      ]),
      generatedPointsView()
    ]);
  }

  return m('pre.ba.b--mid-gray.pa2.pre-wrap.overflow-auto.near-white', {
    style: { maxHeight: '18rem', whiteSpace: 'pre-wrap' }
  }, body === null || typeof body === 'undefined' ? '' : String(body));
}

function responseTestView() {
  var result = restResource.responseTest.result();
  return helpers.section('Test Request', [
    m('div.flex.items-center.mb2', [
      m('button.ba.bw1.ph3.pv2.tc.v-btm.bg-black.near-white.b--mid-gray.pointer.mr2', {
        type: 'button',
        disabled: restResource.responseTest.loading(),
        style: {
          cursor: restResource.responseTest.loading() ? 'not-allowed' : 'pointer',
          opacity: restResource.responseTest.loading() ? 0.55 : 1
        },
        onclick: testRequest
      }, restResource.responseTest.loading() ? 'Testing...' : 'Test Request'),
      result ? m('span.f5', { class: result.ok ? 'green' : 'gold' }, [
        result.method,
        ' ',
        result.statusCode || '',
        ' ',
        result.url || ''
      ]) : null
    ]),
    restResource.responseTest.error() ? m('div.bg-red.white.pa2.mb2', restResource.responseTest.error()) : null,
    result ? responseBodyView(result) : null
  ]);
}

function fullParentRecord(record, options) {
  return (
    options && options.parentRecord ||
    record && record.parent ||
    record && record.breadcrumbs && record.breadcrumbs[0] ||
    null
  );
}

function saveGeneratedPointConfigs(options) {
  return restResource.save()
  .then(function (data) {
    var callbackResult = options && options.submitCallback ? options.submitCallback(data) : null;
    return Promise.resolve(callbackResult).then(function () {
      modal.vm.close();
      m.redraw();
      return data;
    });
  })
  .catch(function (error) {
    alerts.vm.add({ detail: errorMessage(error) });
    m.redraw();
    return Promise.reject(error);
  });
}

function openResponsePickerModal(record, options) {
  restResource.initForm(record, Object.assign({}, options, {
    parentRecord: fullParentRecord(record, options)
  }));

  modal.vm.title('Create Points from ' + (record.name || 'Rest Resource'));
  modal.vm.body = function () {
    return m('div', [
      restResource.errorView(),
      responseTestView()
    ]);
  };
  modal.vm.buttons([
    {
      label: 'Create Points',
      class: 'btn-good',
      disabled: function () { return readGeneratedPointConfigs().length === 0; },
      func: function () { return saveGeneratedPointConfigs(options); }
    }
  ]);
  modal.vm.open({ extrawidth: true });
}

restResource.openResponsePicker = function (record, options) {
  if (!record || !record['@rid']) {
    alerts.vm.add({ detail: 'Save the Rest Resource before creating points from a test response.' });
    m.redraw();
    return Promise.resolve(null);
  }

  if (Array.isArray(record.children) && (record.parent || options && options.parentRecord)) {
    openResponsePickerModal(record, options || {});
    return Promise.resolve(record);
  }

  return loaders.requestWithLoader({
    loader: 'background',
    url: restResource.getUrl(record),
    method: 'GET'
  })
  .then(function (fullRecord) {
    openResponsePickerModal(fullRecord, options || {});
    return fullRecord;
  })
  .catch(function (error) {
    alerts.vm.add({ detail: errorMessage(error) });
    m.redraw();
    return Promise.reject(error);
  });
};

restResource.actions = [
  {
    name: 'Create Points',
    func: function (ctrl) {
      return restResource.openResponsePicker(ctrl.record, {
        parentRecord: fullParentRecord(ctrl.record, {}),
        submitCallback: ctrl.init
      });
    }
  }
];

restResource.initForm = function (record, options) {
  initForm.call(restResource, record, options);
  restResource.parentRecord = options && options.parentRecord ? options.parentRecord : null;
  restResource.showRequestDetails = prop(hasRequestDetails());
  restResource.showResponseDetails = prop(hasResponseDetails());
  restResource.showWriteDetails = prop(hasWriteDetails());
  resetResponseTest();
};

restResource.initForm();

restResource.view = function () {
  var writeMode = writeModeValue();

  return m('form', { role: 'form' }, [
    restResource.errorView(),
    helpers.section('Endpoint', [
      helpers.columns([
        helpers.text(restResource, 'name', 'Name', 'Display name for the resource and its default point.'),
        helpers.text(restResource, 'interval', 'Interval seconds', 'Polling interval. Use 0 to rely on the worker default.')
      ]),
      helpers.columns([
        helpers.text(restResource, 'path', 'Path', 'Path appended to the host API root.'),
        helpers.select(restResource, 'requestType', 'Method', POLL_METHODS, 'Read-only HTTP method used when polling this resource.')
      ])
    ]),
    helpers.section('Request', [
      helpers.switchField('Configure request details', 'Leave off for a simple request that only uses method and path.', function () {
        return restResource.showRequestDetails();
      }, function (enabled) {
        restResource.showRequestDetails(enabled);
      }),
      restResource.showRequestDetails() ? [
        helpers.columns([
          helpers.textarea(restResource, 'queryParams', 'Query parameters', 'JSON object, query-string pairs, or one key=value per line.'),
          helpers.textarea(restResource, 'requestHeaders', 'Headers', 'Resource-specific headers merged after host defaults.')
        ]),
        helpers.select(restResource, 'bodyType', 'Body type', BODY_TYPES, 'Used when the polling request has a body.'),
        helpers.textarea(restResource, 'postBody', 'Body', 'JSON object/array, form pairs, or raw text according to Body type.', { tall: true }),
        helpers.text(restResource, 'timeout', 'Timeout ms', 'Overrides the host timeout for this resource.')
      ] : null
    ]),
    helpers.section('Response', [
      helpers.switchField('Configure response details', 'Leave off to use the host response parser and no resource status check.', function () {
        return restResource.showResponseDetails();
      }, function (enabled) {
        restResource.showResponseDetails(enabled);
      }),
      restResource.showResponseDetails() ? [
        helpers.columns([
          helpers.select(restResource, 'responseFormat', 'Response format', RESPONSE_FORMATS, 'Parser override for this resource.', {
            value: responseFormatValue,
            onchange: function (ev) { setResponseFormat(ev.target.value); }
          }),
          helpers.select(restResource, 'allowNon2xx', 'Allow non-2xx', [
            { name: 'No', value: '' },
            { name: 'Yes', value: 'true' }
          ], 'When enabled, non-2xx responses are returned to parsing instead of rejected by request-promise.')
        ]),
        helpers.columns([
          helpers.text(restResource, 'arrayKey', 'Array key', 'Path to the array when the response wraps point values.'),
          helpers.text(restResource, 'statusIndex', 'Status path', 'Optional response path used for resource status checks.')
        ]),
        helpers.text(restResource, 'statusNormalValue', 'Normal status value', 'Expected value at the status path.')
      ] : null
    ]),
    helpers.section('Writes', [
      helpers.switchField('Configure writes', 'Leave off to keep the default write request shape.', function () {
        return restResource.showWriteDetails();
      }, function (enabled) {
        restResource.showWriteDetails(enabled);
      }),
      restResource.showWriteDetails() ? [
        helpers.select(restResource, 'writeMode', 'Write mode', [
          { name: 'Default request', value: 'default' },
          { name: 'Custom request', value: 'custom' },
          { name: 'Disabled', value: 'disabled' }
        ], 'Default writes POST { "value": value } or an array body for array resources.', {
          value: writeModeValue,
          onchange: function (ev) { restResource.form.writeMode(ev.target.value); }
        }),
        writeMode === 'default' ? helpers.text(restResource, 'writeValueKey', 'Default value key', 'JSON key used by default single-point writes. Default: value.') : null,
        writeMode === 'custom' ? helpers.section('Custom Write Request', [
          helpers.columns([
            helpers.select(restResource, 'writeMethod', 'Write method', WRITE_METHODS, 'HTTP method used for writes.'),
            helpers.text(restResource, 'writePath', 'Write path', 'Supports {pointName}, {pointRid}, {value}, {jsonValue}, and {timestamp}.')
          ]),
          helpers.select(restResource, 'writeBodyType', 'Write body type', BODY_TYPES, 'Controls how the write body template is sent.', {
            value: writeBodyTypeValue,
            onchange: function (ev) { restResource.form.writeBodyType(ev.target.value); }
          }),
          helpers.textarea(restResource, 'writeBody', 'Write body template', 'Templates can include {value}, {rawValue}, {jsonValue}, {values}, and {jsonValues}.', { tall: true }),
          helpers.textarea(restResource, 'writeHeaders', 'Write headers', 'Headers merged only for write requests.', { tall: true })
        ]) : null
      ] : null
    ])
  ]);
};

module.exports = restResource;
